import { css } from 'aphrodite';
import moment from 'moment';
import React, { useState } from 'react';
import { useAdminAccountInsightsQuery } from '../../../../queries/Admin/Account/useAdminAccountInsightsQuery';
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from '../../../../web/components-v2/Collapsible';
import { StreamdownLite } from '../../../../web/components-v2/ai/StreamdownLite';
import { AIStarsIcon } from '../../../../web/components/svgs/icons/AIStars';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { styleSheet } from './styles';

interface AccountInsightsBannerProps {
	accountId: string;
}

export const AccountInsightsBanner: React.FC<AccountInsightsBannerProps> = ({ accountId }) => {
	const [isOpen, setIsOpen] = useState(false);
	const { data, isLoading, isError } = useAdminAccountInsightsQuery({ accountId, enabled: !!accountId });

	if (isError) {
		return null;
	}

	if (!isLoading && !data) {
		return null;
	}

	if (isLoading) {
		return (
			<div className={css(styleSheet.container)}>
				<div className={css(styleSheet.loading)}>
					<LoadingSpinner type='tiny' />
					<span>Loading Account Insights...</span>
				</div>
			</div>
		);
	}

	const formattedDate = data?.generatedAt ? moment(data.generatedAt).format('MMM D, YYYY h:mm A') : '';

	return (
		<div className={css(styleSheet.container)}>
			<Collapsible open={isOpen} onOpenChange={setIsOpen}>
				<div className={css(styleSheet.header)}>
					<div className={css(styleSheet.headerLeft)}>
						<AIStarsIcon />
						<span className={css(styleSheet.label)}>AI Account Insights</span>
						{formattedDate && <span className={css(styleSheet.timestamp)}>{formattedDate}</span>}
					</div>
					<CollapsibleTrigger className={css(styleSheet.toggleButton)}>
						{isOpen ? 'Show less' : 'Show more'}
					</CollapsibleTrigger>
				</div>
				<CollapsiblePanel>
					<div className={css(styleSheet.content)}>
						<StreamdownLite allowedLinkPrefixes={['https://', 'http://']} allowedImagePrefixes={['https://']}>
							{data?.summary ?? ''}
						</StreamdownLite>
					</div>
				</CollapsiblePanel>
			</Collapsible>
		</div>
	);
};
